import { Theme } from '@pasteltech/theme-provider'
import { colorTheme } from './color-theme'
import { sizes } from './sizes'

export const appTheme: Theme = {
  colors: colorTheme,
  icons: {},
  sizes,
}
type AppColorTheme = typeof colorTheme

declare module '@pasteltech/theme-provider' {
  interface ColorTheme extends AppColorTheme {}
}
